import { add_payment_info } from './event/add_payment_info';
import { add_shipping_info } from './event/add_shipping_info';
import { add_to_cart } from './event/add_to_cart';
import { add_to_wishlist } from './event/add_to_wishlist';
import { begin_checkout } from './event/begin_checkout';
import { close_convert_lead } from './event/close_convert_lead';
import { close_unconvert_lead } from './event/close_unconvert_lead';
import { disqualify_lead } from './event/disqualify_lead';
import { earn_virtual_currency } from './event/earn_virtual_currency';
import { exception } from './event/exception';
import { generate_lead } from './event/generate_lead';
import { join_group } from './event/join_group';
import { level_end } from './event/level_end';
import { level_start } from './event/level_start';
import { login } from './event/login';
import { page_view } from './event/page_view';
import { post_score } from './event/post_score';
import { purchase } from './event/purchase';
import { qualify_lead } from './event/qualify_lead';
import { refund } from './event/refund';
import { remove_from_cart } from './event/remove_from_cart';
import { search } from './event/search';
import { select_content } from './event/select_content';
import { select_item } from './event/select_item';
import { select_promotion } from './event/select_promotion';
import { share } from './event/share';
import { sign_up } from './event/sign_up';
import { spend_virtual_currency } from './event/spend_virtual_currency';
import { tutorial_begin } from './event/tutorial_begin';
import { tutorial_complete } from './event/tutorial_complete';
import { unlock_achievement } from './event/unlock_achievement';
import { view_cart } from './event/view_cart';
import { view_item } from './event/view_item';
import { view_item_list } from './event/view_item_list';
import { view_promotion } from './event/view_promotion';
import { view_search_results } from './event/view_search_results';
import { working_lead } from './event/working_lead';

export const event = {
    add_payment_info,
    add_shipping_info,
    add_to_cart,
    add_to_wishlist,
    begin_checkout,
    close_convert_lead,
    close_unconvert_lead,
    disqualify_lead,
    earn_virtual_currency,
    generate_lead,
    join_group,
    level_end,
    level_start,
    login,
    post_score,
    purchase,
    qualify_lead,
    refund,
    remove_from_cart,
    search,
    select_content,
    select_item,
    select_promotion,
    share,
    sign_up,
    spend_virtual_currency,
    tutorial_begin,
    tutorial_complete,
    unlock_achievement,
    view_cart,
    view_item_list,
    view_item,
    view_promotion,
    working_lead,
    page_view,
    exception,
    view_search_results,
}
